/** @format */

import MessageHistoryActionTypes from './message-history.types';

const INITIAL_STATE = {
  messageHistory: {},
  isFetching: false,
  errorMessage: '',
};

const messageHistoryReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MessageHistoryActionTypes.FETCH_MESSAGE_HISTORY_START:
      return {
        ...state,
        isFetching: true,
      };
    case MessageHistoryActionTypes.FETCH_MESSAGE_HISTORY_SUCCESS:
      return {
        ...state,
        isFetching: false,
        messageHistory: action.payload,
      };
    case MessageHistoryActionTypes.FETCH_MESSAGE_HISTORY_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload,
      };
    default:
      return state;
  }
};

export default messageHistoryReducer;
